import { User } from './user';

/** Order note. */
export class OrderNote {
  constructor(data) {
    this.id = data.id;
    this.orderId = data.orderId;
    this.createDate = data.createDate;
    this.editDate = data.editDate;
    this.isActive = data.isActive;
    this.note = data.note;

    /** @type {User | null} */
    this.user = data.user;
  }
}
